import { IBaseModel, BaseModel } from '../base.model';
import { ITicketChannelAction } from './ticket-channel-action.viewmodel';
import { ITicketChannelParticipant } from './ticket-channel-participant.viewmodel';

export interface ITicketChannel extends IBaseModel {
  actions?: ITicketChannelAction[];
  participants?: ITicketChannelParticipant[];
  fk_channel_ticket?: number;
  channels?: any[]

  name?: string;
  short_url?: string;
  short_url_mobile?: string;
  type?: string;
  state?: string;
}
export class TicketChannel extends BaseModel implements ITicketChannel {
  /**
   *
   */
  actions?: ITicketChannelAction[];
  channels?: any[]
  participants?: ITicketChannelParticipant[];
  fk_channel_ticket?: number;
  name?: string;
  short_url?: string;
  short_url_mobile?: string;
  type?: string;
  state?: string;

  constructor(opt?: ITicketChannel) {
    super(opt);
  }
}



// WEBPACK FOOTER //
// ./src/models/ticket/ticket-channel.viewmodel.ts